import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { MapPin } from 'lucide-react';

import { selectCampAction } from '../../store/user';
import { getSuperDirectorCamps } from '../../services/superDirectorService';
import { resHandle } from '../../helper';

const SuperDirectorCampSelect = props => {
    const [camps, setCamps] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectingCode, setSelectingCode] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        getSuperDirectorCamps().then(res => {
            let { status, data } = resHandle(res);
            if (status) {
                setCamps(data.result || data || []);
            }
            setLoading(false);
        });
    }, []);

    const handleSelect = async camp => {
        if (selectingCode) return;
        setError('');
        setSelectingCode(camp.campCode);
        const result = await props.selectCampAction(camp);
        if (!result?.success) {
            setSelectingCode('');
            setError(typeof result?.error === 'string' ? result.error : 'Unable to sign in to this camp. Please try again.');
        }
    };

    return (
        <div className="container" style={{ paddingTop: '40px', paddingBottom: '80px', minHeight: '60vh' }}>
            <div className="row justify-content-center">
                <div className="col-lg-7">
                    <h3 className="text-center mb-1">Select a Camp</h3>
                    <p className="text-center text-muted mb-4">Choose which camp you'd like to sign in to.</p>
                    {error ? <p className="text-center text-danger mb-4">{error}</p> : null}

                    {loading ? (
                        <p className="text-center">Loading camps...</p>
                    ) : (
                        <div className="d-flex flex-column" style={{ gap: '12px' }}>
                            {camps.map(camp => (
                                <div
                                    key={camp.campCode}
                                    onClick={() => handleSelect(camp)}
                                    className="d-flex justify-content-between align-items-center"
                                    style={{
                                        border: '1px solid #e5e7eb',
                                        borderRadius: '10px',
                                        padding: '16px 20px',
                                        cursor: selectingCode ? 'default' : 'pointer',
                                        opacity: selectingCode && selectingCode !== camp.campCode ? 0.5 : 1,
                                    }}
                                >
                                    <div>
                                        <div style={{ fontWeight: 700 }}>{camp.campName}</div>
                                        {camp.location ? (
                                            <div className="text-muted" style={{ fontSize: '0.85rem', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                <MapPin size={13} /> {camp.location}
                                            </div>
                                        ) : null}
                                    </div>
                                    <button
                                        type="button"
                                        className="btn btn-primary rounded-0"
                                        disabled={!!selectingCode}
                                        onClick={() => handleSelect(camp)}
                                    >
                                        {selectingCode === camp.campCode ? 'Signing In...' : 'Sign In'}
                                    </button>
                                </div>
                            ))}

                            {!camps.length ? <p className="text-center text-muted">No camps available.</p> : null}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const mapDispatchToProps = dispatch => ({
    selectCampAction: camp => dispatch(selectCampAction(camp)),
});

export default connect(null, mapDispatchToProps)(SuperDirectorCampSelect);
